import { CardPattern } from "../interfaces/card-pattern.interface";

export const CARD_PATTERN: CardPattern[] = [
    { cardName: 'mastercard', pattern: /^(?:5[1-5][0-9]{14})$/, backgroundColor: 'linear-gradient(135deg, #45484d 0%, #000000 100%)' },
    { cardName: 'visa', pattern: /^(?:4[0-9]{12}(?:[0-9]{3})?)$/, backgroundColor: 'linear-gradient(135deg, #6764a5 0%, #393381 100%)' },
    { cardName: 'americanexpress', pattern: /^(?:3[47][0-9]{13})$/, backgroundColor: '#016fd0' },
    { cardName: 'discover', pattern: /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/, backgroundColor: 'linear-gradient(135deg, #96979d 0%, #55585d 100%)' },
    { cardName: 'dinersclub', pattern: /^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$/, backgroundColor: 'linear-gradient(135deg, #96979d 0%, #55585d 100%)' },
    { cardName: 'jcb', pattern: /^(?:(?:2131|1800|35\d{3})\d{11})$/, backgroundColor: 'linear-gradient(135deg, rgb(15 84 157) 0%, rgb(20 102 67) 100%)' }
]

